import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Emkan1 from "../../assets/pic/tools/1.jpg"
import Emkan2 from "../../assets/pic/tools/2.jpg"
import Emkan3 from "../../assets/pic/tools/3.png"
import Emkan4 from "../../assets/pic/tools/4.png"
import Emkan5 from "../../assets/pic/tools/5.jpg"
import Emkan6 from "../../assets/pic/tools/6.png"
import Emkan7 from "../../assets/pic/tools/7.jpg"
import Emkan8 from "../../assets/pic/tools/8.png"
import Emkan9 from "../../assets/pic/tools/9.jpg"
import Emkan10 from "../../assets/pic/tools/10.jpg"
import Emkan11 from "../../assets/pic/tools/11.jpg"
import Emkan12 from "../../assets/pic/tools/12.jpg"
import Emkan13 from "../../assets/pic/tools/13.png"
import {Helmet} from "react-helmet";

const Tools = ()=>{
    return(
        <div className='tools-wrap'>
            <Helmet>
                <title>امکانات بل میت</title>
                <meta name="description" content="هرچه بخواهید در اختیار شماست؛ تعامل صوتی و تصویری، اشتراک صفحه نمایش، اشتراک فایل، تخته، محیط چت آنلاین" />
            </Helmet>
            <Nav/>
            <div className="tools-dec">
                <h1>امکانات BellMeet</h1>
                <br/>
                <h2>با هزاران نفر از هر کجای زمین صحبت کنید!</h2>
                <p>
                    BellMeetبستری جامع، دانش بنیان و بومی است که با آن می‌توانید به راحتی و با چند کلیک با هزاران نفر اهداف خود را دنبال کنید. هرچه بخواهید در اختیار شماست؛ تعامل صوتی و تصویری، اشتراک صفحه نمایش، اشتراک فایل، تخته، محیط چت آنلاین و ...
                </p>
                <img src={Emkan1} alt="person"/>
                <h2>بدون نیاز به نصب !</h2>
                <p>
                    پلتفرم جامع BellMeet، نرم افزاری تحت وب (وب اپلیکیشن) است که نیازی به نصب در دستگاه کاربر ندارد. این پلتفرم به راحتی از طریق مرورگر (Browser) در هر دستگاه و سیستم عاملی در دسترس است.
                </p>
                <img src={Emkan2} alt="Os"/>
                <h2>سازگاری با دستگاه‌های مختلف ...</h2>
                <p>
                    پلتفرم جامعBellMeet  به صورت وب اپلیکیشن بوده و با هر دستگاهی نظیر کامپیوتر خانگی، لپ تاپ، تبلت، تلفن همراه، تلویزیون هوشمند و هر سیستم عاملی نظیر ویندوز، مک، لینوکس، اندروید، iOS، سازگار است.
                </p>
                <img className="png" src={Emkan3} alt="device"/>
                <h2>محیط گفت و گوی متنی (چت آنلاین)</h2>
                <p>
                    کاربران حاضر در پلتفرم BellMeet، به راحتی می‌توانند با یکدیگر تعامل متنی (چت) داشته باشند. سوالات خود را بپرسند و به سوالات یکدیگر جواب دهند.
                </p>
                <img className="png" src={Emkan4} alt="Chat"/>
                <h2>اعلانات ...</h2>
                <p>
                    مخاطبین زیادی در جلسات خود دارید ؟!
                    <br/>
                    هوشمندانه تبلیغ و کسب درآمد کنید !
                    <br/>
                    با پین کردن پیام یا متن‌ در بخش اعلانات، آن پیام را به صورت یک زیر نویس دوره‌ای در جلسات خود نمایش دهید.
                </p>
                <img src={Emkan5} alt="notification"/>
                <h2>مدیریت آسان کاربران (دسترسی گروهی)</h2>
                <p>
                    نیازی به صرف وقت برای دادن دسترسی و یا تغییرات آن به تک تک کاربران نیست! به راحتی دسترسی تمامی کاربران حاضر در جلسه را به صورت گروهی و یکباره تعیین کنید.
                </p>
                <img className="png" src={Emkan6} alt="group access"/>
                <h2>هیچ جلسه‌ای از دست نمی‌رود !</h2>
                <p>
                    تفاوتی ندارد که ارائه داهنده باشید یا کاربر؛ پلتفرم جامع BellMeet با تلفن‌های همراه سازگاری کامل دارد و در هر موقعیتی که باشید و با هر نوع سرویس اینترنتی به راحتی وارد محیط جلسه شوید.
                </p>
                <img src={Emkan7} alt=""/>
                <h2>گچ و ماژیک را فراموش کنید و بی‌نهایت بنویسید !</h2>
                <p>
                    هر آنچه که در ذهن خود دارید را به راحتی روی تخته آنلاین بیاورید. این تخته با لمس دست، نشانگر موس و قلم‌های نوری سازگاری کامل دارد.
                </p>
                <img className="png" src={Emkan8} alt=""/>
                <h2>اشتراک وب کم بدون محدودیت ...</h2>
                <p>
                    با هزاران کاربر به صورت ویدئویی در ارتباط باشید. در پلتفرم جامع BellMeet امکان اشتراک تصویر وب کم تمامی کاربران به صورت هم زمان وجود دارد.
                </p>
                <img src={Emkan9} alt=""/>
                <h2>اشتراک گذاری فایل ها</h2>
                <p>
                    به روز باشید و از محتوای آنلاین استفاده کنید ...
                    <br/>
                    با بارگذاری فایل‌ها و به اشتراک گذاری آن‌ها با کاربران حاضر در جلسه، بازدهی جلسه خود را بالا ببرید، تکالیف دانش پذیران را بدهید، مستندات جلسه را در اختیار همکاران قرار دهید، جزوات را منتشر کنید و ...
                </p>
                <img src={Emkan10} alt=""/>
                <h2>نوشتن روی فایل</h2>
                <p>
                    به راحتی تصاویر و فایل‌های PDF بارگذاری شده در محیط جلسه را نمایش داده و تغییرات دلخواه خود را اعمال کنید. نکات مهم را مشخص کنید، جدول‌ها را پر کنید، گراف‌ها را تحلیل کنید، مسائل را حل کنید و ...
                </p>
                <img src={Emkan11} alt=""/>
                <h2>پخش ویدئو</h2>
                <p>
                    به راحتی فایل‌های ویدئویی خود را با کیفیت بالا در محیط جلسه نمایش دهید و امکان دانلود آن را به کاربران بدهید.
                </p>
                <img src={Emkan12} alt=""/>
                <h2>هر آنچه می‌خواهید با کاربران به اشتراک بگذارید ...</h2>
                <p>
                    با استفاده از قابلیت اشتراک گذاری صفحه نمایش (Share Screen) به راحتی می‌توانید تمام اهداف خود را محقق کنید.
                </p>
                <img className="png" src={Emkan13} alt=""/>
            </div>
            <Footer/>
        </div>
    )
}

export default Tools